export default __webpack_public_path__ + "static/media/profile.079bfdb9.png";